import { connect } from "react-redux";

import { post } from "../../../../../../../actions/general";
import { editTask } from "../../../../../../../store/plan/actions";

import Size from "./Size";

export default connect(null, { post, editTask })(Size);
